export function InvalidJwtError(message) {
	this.name = "InvalidJwtError";
	this.message = message;
}
export function validateJwtToken(jwt): Record<string, any> {
	if (jwt === undefined) {
		throw new InvalidJwtError("JWT token is undefined");
	}

	return jwt;
}
export function isCustomer(jwt): boolean {
	return !!jwt && jwt.payload && jwt.payload.role === "customer";
}
export function isEmployee(jwt): boolean {
	return !!jwt && !!jwt.payload && jwt.payload.role === "employee";
}
export function getTierLevel(jwt: Record<string, any>): string | null | undefined {
	return jwt.payload && jwt.payload.tierLevel;
}

function assertTier(jwt: Record<string, any>, level: string): boolean {
	return getTierLevel(jwt) === level;
}

export function isTier1(jwt: Record<string, any>): boolean {
	return assertTier(jwt, "1");
}
export function isTier2(jwt: Record<string, any>): boolean {
	return assertTier(jwt, "2");
}
export function isTier3(jwt: Record<string, any>): boolean {
	return assertTier(jwt, "3");
}
export function isTier4(jwt: Record<string, any>): boolean {
	return assertTier(jwt, "4");
}
export function getUpn(jwt: Record<string, any>): string | null | undefined {
	return jwt.payload && jwt.payload.upn;
}
export function getCardholderNumber(jwt): string | null | undefined {
	return jwt.payload && jwt.payload.cardholderNumber;
}
